export default {
  en: {
    abstract: "Abstract",
    to_be_removed: "To be removed"
  },
  es : {
    abstract: "Resumen",
    to_be_removed: "Para borrar"
  },
  ca : {
    abstract: "Resume",
    to_be_removed: "Per esborrar"
  }
};
